import { AppBar, Card, CardHeader, Stack, Tab, Tabs } from "@mui/material";
import DashboardLayout from "../layoutcontainers/DashboardLayout";
import MaterialTypography from "../components/MaterialTypography";
import MaterialSelect from "../components/MasterSelect";
import MaterialButton from "../components/MaterialButton";
import AddIcon from "@mui/icons-material/Add";
import MaterialBox from "../components/MaterialBox";
import { useContext, useEffect, useState } from "react";
import MaterialDataGrid from "../components/MaterialDataGrid";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import BASEURL from "./Utils/Baseurl";
import Swal from "sweetalert2";
import CancelIcon from "@mui/icons-material/Cancel";
import { DesignationContext } from "../context/designationcontext";
import { useUserDetails } from "../context/auth";
import ConfirmationDialog from "../components/Dialog/ConfirmationDialog";
import request from "graphql-request";
import { useLoading } from "../context/loading";
import Grid from "@mui/material/Grid2";

const PermissionTable = () => {

  const { handleClearSelection } = useContext(DesignationContext);
  const { AccessData } = useUserDetails();
  const nav = useNavigate();
  const teamleader = JSON.parse(sessionStorage.getItem("user"));
  const tablist = JSON.parse(sessionStorage.getItem("permission"));
  

  const userid = teamleader?.id;
  const teamleaderid = teamleader?.teamleader;

  const [tabsOrientation, setTabsOrientation] = useState("horizontal");
  const { setDesignation } = useContext(DesignationContext);
  const [departmentnames, setdepartmentnames] = useState([]);
  const [tabledata, settabledate] = useState([]);
  const [sampledata, Setsampledata] = useState([]);
  const { setCirleLoading } = useLoading();
  const [department, setdepartment] = useState("");

  const [departmentoption, setdepartmentoption] = useState([]);
  let MainValue;
  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    showConfirm: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
  });
  if (
    AccessData &&
    Array.isArray(AccessData) &&
    AccessData.some(
      (item) => item.component === "HrApproval" && item.can_access
    )
  ) {
    if (tablist === "HR List") {
      MainValue = "HR List";
    } else if (tablist === "Team List") {
      MainValue = "Team List";
    } else {
      MainValue = "Employee";
    }
  }

  if (
    AccessData &&
    Array.isArray(AccessData) &&
    AccessData.some(
      (item) => item.component === "ManagerApproval" && item.can_access
    )
  ) {
    if (tablist === "Team List") {
      MainValue = "Team List";
    } else {
      MainValue = "Employee";
    }
  }

  if (
    AccessData &&
    Array.isArray(AccessData) &&
    !AccessData.some(
      (item) =>
        item.component === "ManagerApproval" || item.component === "HrApproval"
    )
  ) {
    MainValue = "Employee";
  }

  const [value, setValue] = useState(MainValue || "Employee");

  const onDepartmentDropdown = async () => {
    // setCirleLoading(true)
    const query = `query {
                        allDepartment {
                        id
                        departmentName
                        departmentCode
                        }
                    }`;

    try {
      const response = await axios.post(
        BASEURL,
        {
          query: query,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      // Extract department data from the response
      let departmentListdata = response.data.data.allDepartment;

      departmentListdata = departmentListdata?.map((department) => ({
        value: department?.id,
        code: department?.departmentCode,
        label: department?.departmentName,
      }));

      setdepartmentoption(departmentListdata);

      // console.log('Response departmentListdata:', departmentListdata);
    } catch (error) {
      // setCirleLoading(false)
      console.error("ResponseError:", error);
    }
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
    
    if (newValue == "HR List") {
      sessionStorage.setItem("permission", JSON.stringify(newValue));
    } else if (newValue == "Manager") {
    } else if (newValue == "Team List") {
      sessionStorage.setItem("permission", JSON.stringify(newValue));
    } else if (newValue == "ManagerList") {
      sessionStorage.setItem("permission", JSON.stringify(newValue));
    } else if (newValue == "Employee") {
      sessionStorage.setItem("permission", JSON.stringify(newValue));
    }
  };

  useEffect(() => {
    onDepartmentdata();
    onDepartmentDropdown();
    const tabName = JSON.parse(sessionStorage.getItem("permission"));

if(tabName){
  setValue(tabName);
}else{
  setValue("Employee");
}
  }, []);

  useEffect(() => {
    fetchpermissiondata();
  }, [value, department]);

  const fetchpermissiondata = async () => {
    const allpermission = `
    query GetPermissions($department_ids: [ID]) {
  permissions(departmentIds: $department_ids) {
    success
    error
    message
    data {
      id
      user {
        id
        username
        firstName
        lastName
        department
      }
      balanceHours
      permissionOn
      permissionFrom
      permissionTill
      teamApproval 
      hrApproval 
      status 
      approvalStatus {
        status
        approver{ 
          id 
          firstName 
          lastName 
          email 
        } 
      }
    }
  }
}`;

    const teamleader = `
    query GetPermissionsByTeamLeader($teamleader_id: ID!, $department_ids: [ID]) {
  permissionsByTeamleader(teamleaderId: $teamleader_id, departmentIds: $department_ids) {
    success
    error
    message
    data {
      id
      balanceHours
      permissionOn
      permissionFrom
      permissionTill
      teamApproval 
      hrApproval 
      status 
        user {
          id
          username
          firstName
          lastName
          department
        }
        approvalStatus {
          status
          approver{ 
          id 
          firstName 
          lastName 
          email 
        } 
      }
    }
  }
}`;
    const mylist = `    
    query GetPermissionsByUser($user_id: ID!, $department_ids: [ID]) {
  permissionsByUser(userId: $user_id, departmentIds: $department_ids) {
    success
    error
    message
    data {
      id
      balanceHours
      permissionOn
      permissionFrom
      permissionTill
      teamApproval 
      hrApproval 
      status 
      user {
        id
        username
        firstName
        lastName
        department
      }
      approvalStatus {
        status
        approver{ 
          id 
          firstName 
          lastName 
          email 
        } 
      }
    }
  }
}`;
    try {      

      const res = await axios.post(BASEURL, {
        query:
          value === "HR List"
            ? allpermission
            : value === "Team List"
            ? teamleader
            : mylist,
        variables:
          value === "HR List"
            ? { department_ids: department ? [department?.label] : [] }
            : value === "Team List"
            ? {
                teamleader_id: userid,
                department_ids: department ? [department.label] : [],
              }
            : {
                user_id: userid,
                department_ids: department ? [department.label] : [],
              },
      });      
      if (res) {
        const rowdata =
          value === "HR List"
            ? res.data.data.permissions.data
            : value === "Team List"
            ? res.data.data.permissionsByTeamleader.data
            : res.data.data.permissionsByUser.data;    
        settabledate(rowdata);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const onDepartmentdata = async () => {
    const query = `query {
        allDepartment {
            id
            departmentName
            departmentCode
        }
    }`;

    try {
      // setPageState({ ...pageState, loading: true });

      const response = await axios.post(
        BASEURL,
        {
          query: query,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const departmentList = response.data.data.allDepartment;
      setdepartmentnames(departmentList);
    } catch (error) {
      console.error("ResponseError:", error);
    }
  };

  const cancelpermission = `
 mutation CancelPermission($permissionId: ID!) {
  CancelPermission(permissionId: $permissionId) {
    success
    message
    error
  }
}`;

  const AddDiscard = (id) => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to cancel your permission.",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        cancelpermissionmethod(id);
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const cancelpermissionmethod = async (id) => {
    setCirleLoading(true);
    try {
      const res = await request(BASEURL, cancelpermission, {
        permissionId: id,
      });
      Swal.fire({
        position: "center",
        icon: "success",
        title: "Permission Cancelled Successfully!",
        showConfirmButton: false,
        timer: 2500,
      });
      // getteamleadeID();
      onDepartmentdata();
    } catch (err) {
      Swal.fire({
        position: "center",
        icon: "error",
        title: err?.response?.errors[0]?.message,
        showConfirmButton: false,
        timer: 2500,
      });
      onDepartmentdata();
    } finally {
      setCirleLoading(false);
      onDepartmentdata();
    }
  };

  // useEffect(() => {
  //   getteamleadeID();
  // }, []);

  //   const getteamleadeID = async () => {
  //     const query = `
  //    query{
  //   allManagers{
  //     id
  //     status
  //     lastupdate
  //     user{
  //       id
  //       empid
  //       department
  //       firstName
  //       lastName

  //     }
  //   }
  // }
  // `;

  //     try {
  //       // setPageState({ ...pageState, loading: true });

  //       const response = await axios.post(
  //         BASEURL,
  //         {
  //           query: query,
  //         },
  //         {
  //           headers: {
  //             "Content-Type": "application/json",
  //           },
  //         }
  //       );

  //       const managerList = response.data.data.allManagers;
  //       const filterdata = managerList.filter(
  //         (val) => val.user.empid == teamleader.empid
  //       );
  //       let dataid = filterdata[0]?.user?.id;
  //       localStorage.setItem("team", dataid);
  //       setTeamLeaderID(filterdata);
  //     } catch (error) {
  //       console.error("ResponseError:", error);
  //     }
  //   };

  useEffect(() => {
    handleClearSelection();

    if (value == "Employee") {
      const query = `
   
     query PermissionRequestByUserId($userid: ID!){ 

  permissionsByUser(userId: $userid){ 

    data{ 
id
      user{ 

      id 

      firstName 

      lastName 

      email 

    } 

    permissionOn 

    permissionFrom 

    permissionTill 
    
      teamApproval 

      hrApproval 

    status 

    approvalStatus{ 

      id 

      approver{ 

        id 

        firstName 

        lastName 

        email 

      } 

      status 

    } 

     

    } 

    message 

    success 

    error 

  } 

} 
               
                `;

      const fetchpermission = async () => {
        try {
          const res = await axios.post(
            BASEURL,
            {
              query: query,
              variables: {
                userid: teamleader.id,
              },
            },
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );

          settabledate(res.data.data.permissionsByUser?.data);
        } catch (error) {
          console.log(error);
          settabledate([]);
        }
      };

      // fetchpermission();
    }

    if (value == "HR List") {
      console.log("inside Hrlist");

      const query = `
   
      query PermissionRequestAllList{ 

  permissions{ 

    data{ 

      id 

      user{ 

      id 

      firstName 

      lastName 

      email 

    } 

    permissionOn 

    permissionFrom 

    permissionTill 

    status 
       teamApproval 

      hrApproval 

    approvalStatus{ 

      id 

      approver{ 

        id 

        firstName 

        lastName 

        email 

      } 

      status 

    } 

     

    } 

    message 

    success 

    error 

  } 

} 
             
             
             
              `;

      const fetchpermission = async () => {
        try {
          const res = await axios.post(
            BASEURL,
            {
              query: query,
            },
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );
          console.log(res.data.data.permissions?.data, "tableres");
          settabledate(res.data.data.permissions?.data);
          Setsampledata(res.data.data.permissions?.data);
        } catch (error) {
          console.log(error);
          settabledate([]);
        }
      };

      // fetchpermission();
    }
    if (value == "Team List") {
      const query = `
   
   query PermissionRequestByTeamLeader($teamleader_id: ID!){ 

  permissionsByTeamleader(teamleaderId: $teamleader_id){ 

    data{ 
    id

      user{ 

      id 

      firstName 

      lastName 

      email 

    } 

    permissionOn 

    permissionFrom 

    permissionTill 

    status 
       teamApproval 

      hrApproval 

    approvalStatus{ 

      id 

      approver{ 

        id 

        firstName 

        lastName 

        email 

      } 

      status 

    } 

     

    } 

    message 

    success 

    error 

  } 

} 
             
             
              `;

      const fetchpermission = async () => {
        try {
          const res = await axios.post(
            BASEURL,
            {
              query: query,
              variables: {
                teamleader_id: teamleader?.id,
              },
            },
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );
          console.log(res.data.data.permissionsByTeamleader?.data, "Teamlist");
          settabledate(res.data.data.permissionsByTeamleader?.data);
        } catch (error) {
          console.log(error);
          settabledate([]);
        }
      };

      // fetchpermission();
    }
  }, [value]);

  const Permission = {
    columns: [
      ...(value === "Employee"
      ? [
          {
            field: "cancelpermission",
            headerName: "Cancel Permission",
            width: 200,
            disableColumnMenu: true,
            editable: false,
            sortable: true,
            filter: false,
          },
        ]
      : []),
      {
        field: "username",
        headerName: "User Name",
        width: 200,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
        filter: true,
      },

      {
        field: "allstatus",
        headerName: "Permission Status",
        width: 200,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
        filter: true,
      },

      {
        field: "permissionOn",
        headerName: "Permission On",
        width: 200,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
        filter: true,
      },
      {
        field: "permissionFrom",
        headerName: "Permission From",
        width: 200,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
        filter: true,
      },
      {
        field: "permissionTill",
        headerName: "Permission Till",
        width: 200,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
        filter: true,
      },
    ],

    rows: tabledata.map((permission) => ({
      id: permission?.id,
      cancelpermission:
        value === "Employee" ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              position: "relative",              
            }}
          >
            <CancelIcon
              onClick={(event) => {
                event.stopPropagation();
                AddDiscard(permission.id);
              }}
              sx={{
                fontSize: "100px",
                width: 28,
                marginBottom: 10,
                height: 30,
                transition: `transform 0.2s ease-in-out`,
                "&:hover": {
                  transform: "translateY(-2px)",
                  transition: `transform 0.2s ease-in-out`,
                },
              }}
            />
          </div>
        ) : null,
      teamApproval: permission.teamApproval
        ? permission.teamApproval?.charAt(0).toUpperCase() +
          permission.teamApproval?.slice(1)
        : "",

      hrApproval: permission.hrApproval
        ? permission.hrApproval?.charAt(0).toUpperCase() +
          permission.hrApproval?.slice(1)
        : "",

      username: permission?.user?.firstName ? (permission?.user?.firstName + " " + permission?.user?.lastName) : "N/A" ,
      permissionOn: permission?.permissionOn || "N/A",
      permissionFrom: permission?.permissionFrom || "N/A",
      permissionTill: permission?.permissionTill || "N/A",
      allstatus:
        permission.status == "pending"
          ? permission.approvalStatus !== null
            ? "Pending By " +
              permission.approvalStatus?.approver?.firstName +
              " " +
              permission.approvalStatus?.approver?.lastName
            : permission?.hrApproval == "pending"
            ? "Pending By Hr"
            : "Approved By Hr"
          : permission.status == "rejected"
          ? "Rejected"
          : permission.status == "approved"
          ? "Approved"
          : permission.status === "Cancelled"
          ? "Cancelled"
          : "",
      status:
        permission.status?.charAt(0).toUpperCase() +
        permission.status?.slice(1),
    })),
  };

  const onRowClick = (e) => {
    console.log(e, "event");

    if (!e?.id) return;

    const { hrApproval, teamApproval, status } = e.row;

    if (value === "Employee") {
      const viewConditions = [
        hrApproval === "Pending" &&
          teamApproval === "Approved" &&
          status === "Approved",
        hrApproval === "Pending" &&
          teamApproval === "Approved" &&
          status === "Pending",
        hrApproval === "Pending" &&
          teamApproval === "Rejected" &&
          status === "Rejected",
        hrApproval === "Rejected" &&
          teamApproval === "Rejected" &&
          status === "Rejected",
      ];

      if (viewConditions.some(Boolean)) {
        nav(`/permission/ViewScreen_Premission?id=${e.id}`);
        return;
      }

      if (
        hrApproval === "Pending" &&
        teamApproval === "Pending" &&
        status === "Pending"
      ) {
        console.log("Correct");
        nav(`/permission/requestpermission?id=${e.id}`);
        return;
      }

      console.log("rowclicked");
    }

    setDesignation({ value });
    nav(`/permission/approve?id=${e.id}`);
  };

  const handleclick = () => {
    nav("/permission/request-permission");
  };
  const [Valuedep, setValuedep] = useState({ value: "All", label: "All" });
  const handlechangeDep = (selectedOption) => {
    let data = selectedOption.label;

    if (data == "All") {
      settabledate(sampledata);
    } else {
      let filterdata = sampledata.filter((val) => val.user.department == data);
      settabledate(filterdata);
    }
  };

  return (
    <DashboardLayout>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
        />
      )}
      <Card>
        <CardHeader
          title={
            <>
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                spacing={2}
                margin={1}
              >
                <Stack direction="column" spacing={0}>
                  <MaterialTypography variant="h5" fontWeight="medium">
                    Permission List
                  </MaterialTypography>
                </Stack>

                <MaterialBox alignItems="center" width="60%">
                  <MaterialBox width="80%">
                    <div style={{ position: "relative", left: "20px" }}>
                      <AppBar position="static">
                        <Tabs
                          orientation={tabsOrientation}
                          value={value}
                          onChange={handleChange}
                          sx={{ backgroundColor: "transparent" }}
                        >
                          {AccessData &&
                            Array.isArray(AccessData) &&
                            AccessData.some(
                              (item) =>
                                item.module === "Permission" &&
                                item.component === "HrApproval" &&
                                item.can_access
                            ) && <Tab label="HR List" value="HR List" />}
                          {AccessData &&
                            Array.isArray(AccessData) &&
                            AccessData.some(
                              (item) =>
                                (item.module === "Permission" &&
                                  item.component === "HrApproval" &&
                                  item.can_access) ||
                                (item.module === "Permission" &&
                                  item.component === "ManagerApproval" &&
                                  item.can_access)
                            ) && <Tab label="Team List" value="Team List" />}

                          {/* {AccessData &&
                            Array.isArray(AccessData) &&
                            AccessData.some(
                              (item) =>
                                item.component === "ManagerApproval" &&
                                item.can_access
                            ) && <Tab label="Team List" value="Team List" />} */}

                          <Tab label="My List" value="Employee" />
                        </Tabs>
                      </AppBar>
                    </div>
                  </MaterialBox>
                </MaterialBox>

                <Stack alignItems="" lineHeight={1}>
                  {AccessData &&
                    Array.isArray(AccessData) &&
                    AccessData.some(
                      (item) =>
                        item.component === "AddPermission" && item.can_access
                    ) && (
                      <MaterialButton
                        variant="gradient"
                        color="dark"
                        size="small"
                        startIcon={<AddIcon />}
                        onClick={handleclick}
                      >
                        Request Permission
                      </MaterialButton>
                    )}
                </Stack>
              </Stack>
              {AccessData &&
                Array.isArray(AccessData) &&
                AccessData.some(
                  (item) => item.component === "HrApproval" && item.can_access
                ) && (
                  <Stack
                    direction="column"
                    mt={2}
                    padding={1}
                    spacing={1}
                    width="300px"
                  >
                    {/* Label Above */}
                    {/* <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                      color="black"
                    >
                      Department
                    </MaterialTypography> */}

                    {/* Dropdown Below */}
                    {/* <MaterialSelect
                      name="status"
                      // isMulti
                      value={Valuedep}
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          minHeight: "40px",
                          maxHeight: "40px",
                          width: "100%", // Ensures it respects the Stack width
                          textAlign: "left",
                        }),
                      }}
                      onChange={handlechangeDep}
                      options={[
                        { value: "All", label: "All" },
                        ...departmentnames.map((value) => ({
                          value: value.id,
                          label: value.departmentName,
                        })),
                      ]}
                      error={false}
                      isSearchable={true}
                    /> */}
                  </Stack>
                )}
            </>
          }
        />

        {value != "Employee" && (
          <Grid
            container
            spacing={1}
            size={{ xs: 12, md: 12, lg: 12 }}
            sx={{ padding: 3 }}
          >
            <Grid size={{ xs: 12, sm: 4, lg: 4 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Department <span style={{ color: "red" }}>*</span>
                </MaterialTypography>
              </MaterialBox>
              <MaterialSelect
                name="department"
                customStyles={{ optionPadding: 20 }}
                value={department}
                onChange={(e) => setdepartment(e)} //selectedValue, event
                options={departmentoption}
                // error={employeeData.departmentStatus === "error" ? true : false}
                // success={employeeData.departmentStatus === "success" ? true : false}
                // isDisabled={togglePage.view === true ? true : false}
                // isClearable
              />
              {/* {validationMessages.department && (
                            <label style={{ color: "red", fontSize: "12px" }}>
                              {validationMessages.department} */}
              {/* </label> */}
            </Grid>
          </Grid>
        )}

        <MaterialDataGrid
          customHeight={500}
          rows={Permission.rows}
          columns={Permission.columns}
          checkboxSelection={false}
          isSelectable={true}
          onRowClick={onRowClick}
          loading={""}
          localeText={{
            noRowsLabel: (
              <Stack
                direction="column"
                alignItems="center"
                justifyContent="center"
                spacing={1}
              >
                <MaterialTypography
                  variant="body2"
                  fontWeight="medium"
                  color="text"
                >
                  No Permission request found
                </MaterialTypography>
                <MaterialTypography variant="caption" color="text">
                  You have not yet add any Permission request details. Click on
                  the "Request Permission" button to start adding Permission
                  details.
                </MaterialTypography>
              </Stack>
            ),
          }}
        />
      </Card>
    </DashboardLayout>
  );
};

export default PermissionTable;
